document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.aa-store-locator');
  if (!section) return;

  const input = section.querySelector('.aa-store-locator__search-input');
  const results = section.querySelector('[data-locator-results]');
  const empty = section.querySelector('[data-locator-empty]');
  const count = section.querySelector('[data-locator-count]');
  const cards = Array.from(section.querySelectorAll('[data-locator-card]'));
  const groups = Array.from(section.querySelectorAll('[data-locator-group]'));
  if (!input) return;

  const filter = () => {
    const query = input.value.trim().toLowerCase();
    let visibleCount = 0;

    cards.forEach((card) => {
      const matches = query === '' || card.dataset.locatorSearch.includes(query);
      card.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    groups.forEach((group) => {
      const hasVisibleCard = group.querySelector('[data-locator-card]:not([hidden])');
      group.hidden = !hasVisibleCard;
    });

    if (count) {
      // Live updates use the plural form for simplicity — the initial
      // server-rendered count (before any typing) already uses correct
      // singular/plural grammar via Liquid's pluralized translation.
      count.textContent = count.dataset.labelPlural.replace('{{ count }}', visibleCount);
    }

    if (results) results.hidden = visibleCount === 0;
    if (empty) empty.hidden = visibleCount !== 0;
  };

  let debounce;
  input.addEventListener('input', () => {
    clearTimeout(debounce);
    debounce = setTimeout(filter, 150);
  });

  const params = new URLSearchParams(window.location.search);
  // ?q= comes from the homepage teaser's search form; ?partner= comes from
  // the Our Partners page's deep-link filter. Both land in the same input
  // and trigger the same client-side filter.
  const query = params.get('q') || params.get('partner');
  if (query) {
    input.value = query;
    filter();
  }
});
